import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
	Box,
	Divider,
	FormControlLabel,
	IconButton,
	Radio,
	RadioGroup,
	Typography
} from '@material-ui/core';
import linkedItemsFormStyle from './LinkedItemsForm.style';
import {
	LINK_ITEMS_NUM_BTN_TEXT,
	NONE,
	NO_LINKED_ACTIVITY,
	ALL_LINK_ROLLUP,
	ALL_LINK_ROLLUP_DESC,
	ALL_LINK_ROLL_DETAIL,
	ALL_LINK_ROLL_DETAIL_DESC,
	LINK_ACTIVITY_SAVED_SUCCESS,
	AllLinkRollUp
} from 'constants/constant';
import LinearScaleIcon from '@material-ui/icons/LinearScale';
import CloseIcon from '@material-ui/icons/Close';
import { deepClone } from 'helper/helper';
import { setSelectedList, setLinkItemActivity } from '../Preview.actions';
import RBSnackbar from 'components/Shared/RBSnackbar';

function LinkedItemsForm(props) {
	const { cbSetShowPreviewElement } = props;
	const classes = linkedItemsFormStyle();
	const dispatch = useDispatch();

	const selectedTemplate = useSelector((state) => state.templateReducer.selectedTemplate);
	const templateData = useSelector((state) => state.templateReducer.templateData);
	const selectedList = useSelector((state) => state.previewReducer.selectedList);
	const linkItemActivity = useSelector((state) => state.previewReducer.linkItemActivity);

	const [value, setValue] = useState(linkItemActivity);
	const [openSnackbar, setSnackbar] = useState({ open: false, msg: '' });
	const techNmForLinkActivity = ['all_links_item_number', 'walmart_item_number'];

	const handleLinkChange = (event) => {
		const val = event.currentTarget?.value;
		setValue(val);
		const duplicateSelectedList = deepClone(selectedList);

		/**
		 * Prepare the array with dimesions that would be added if any of the selection has been made
		 */
		const linkedDimToBeAdded = [];

		const data = templateData.filter((td) => td.templateId === `${selectedTemplate}`);

		data[0].dimensions.filter((dim) => {
			if (techNmForLinkActivity.includes(dim.technicalName)) {
				dim.parent = 'dimensions';
				linkedDimToBeAdded.push(dim);
			}
		});

		linkedDimToBeAdded.forEach((dim) => {
			if (!selectedList.map((item) => item.technicalName).includes(dim.technicalName)) {
				duplicateSelectedList.push(dim);
			}
		});
		// If the selected option is 'allLinkRollUp' and the selected column is 'unit_cost_amt', then it should be removed from the list
		// as this is throwing an exception in the backend.
		const newSelectedList = duplicateSelectedList.filter(
			(item) =>
				!(
					val === AllLinkRollUp &&
					['manufacturing_company_id', 'unit_cost_amount'].includes(item.technicalName)
				)
		);

		dispatch(setLinkItemActivity(val));
		dispatch(setSelectedList(newSelectedList));
		setSnackbar({ open: true, msg: LINK_ACTIVITY_SAVED_SUCCESS, type: 'success' });
	};

	const hideSnackbar = () => {
		setSnackbar({ open: false, msg: '', guidedBtn: false });
	};

	return (
		<Box className={classes.relative}>
			<Box style={{ marginBottom: '24px' }}>
				<Box
					aria-controls="link-items-activity-header"
					className={classes.titleContainer}
					id="link-items-activity-header">
					<Typography className={classes.titleFont}>
						<LinearScaleIcon color="primary" className={classes.titleIcon} />
						<span>{LINK_ITEMS_NUM_BTN_TEXT}</span>
						<IconButton
							size="small"
							aria-label="Close"
							className={classes.closeIcon}
							onClick={() => cbSetShowPreviewElement()}>
							<CloseIcon />
						</IconButton>
					</Typography>
					<Divider />
				</Box>
				<Box className={classes.contentContainer}>
					<RadioGroup
						aria-labelledby="link-items-activity"
						defaultValue={linkItemActivity}
						value={value}
						name="link-items-radio-group"
						onChange={(e) => handleLinkChange(e)}
						id="link-items-radio-group">
						<FormControlLabel
							value="allLinkRollUp"
							control={
								<Radio color="primary" size="small" tabIndex="0" className={classes.allLinkRadio} />
							}
							label={ALL_LINK_ROLLUP}
						/>
						<span className={classes.descriptionLable}>{ALL_LINK_ROLLUP_DESC}</span>
						<FormControlLabel
							value="allLinkRollDetails"
							control={
								<Radio color="primary" size="small" tabIndex="0" className={classes.allLinkRadio} />
							}
							label={ALL_LINK_ROLL_DETAIL}
						/>
						<span className={classes.descriptionLable}>{ALL_LINK_ROLL_DETAIL_DESC}</span>
						<FormControlLabel
							value=""
							control={
								<Radio color="primary" size="small" tabIndex="0" className={classes.allLinkRadio} />
							}
							label={NONE}
						/>
						<span className={classes.descriptionLable}>{NO_LINKED_ACTIVITY}</span>
					</RadioGroup>
				</Box>
			</Box>
			<RBSnackbar
				doOpen={openSnackbar.open}
				msg={openSnackbar.msg}
				doClose={hideSnackbar}
				type={openSnackbar.type}
			/>
		</Box>
	);
}

export default LinkedItemsForm;
